import { GetServerSideProps } from 'next'
import React from 'react'
import { withPublic } from '../src/component'
import { getLayout } from '../src/layouts/MainLayout'
import { CheckoutPage } from '../src/model'
import { PasswordPage as Password } from '../src/page'
import { createCombinedServerSideProps } from '../src/utils/server/page-props'

const I18N_NAMESPACE = ['common', 'terminalError', 'password', 'login', 'verify']

const PasswordPage: CheckoutPage = (props) => <Password {...props} />

export const getServerSideProps: GetServerSideProps = createCombinedServerSideProps(I18N_NAMESPACE, async () => {
  return {
    props: {},
  }
})

const PasswordPagePublic: CheckoutPage = withPublic(PasswordPage)
PasswordPagePublic.getLayout = getLayout()

export default PasswordPagePublic
